export const WEB_MODULAR = {
  label: 'Web (modular)',
  value: 'web-modular',
  channel: 'web',
  disabled: false,
  navigationLimit: 8,
  tabs: [
    'screens',
    'navigation',
    'branding',
    'integrations',
    'new-integrations',
    'profile-viewer',
    'products',
    'share',
  ],
  freeformTemplates: [
    {
      label: 'Default',
      template: 'FreeformPage',
      thumbnail: 'web-hero-page.png',
      preset: 'default',
      content: [],
    },
    {
      label: 'Product',
      template: 'FreeformPage',
      thumbnail: 'web-hero-page.png',
      preset: 'product',
      content: [
        {
          meta: { component: 'Container', _columns: 2 },
          styles: {
            gap: '2rem',
          },
          content: [
            [
              {
                meta: {
                  component: 'ProductImage',
                },
                content: {
                  alignment: 'left',
                },
              },
            ],
            [
              {
                meta: {
                  component: 'ProductCategory',
                },
                content: {
                  alignment: 'left',
                },
              },
              {
                meta: {
                  component: 'ProductName',
                },
                content: {
                  alignment: 'left',
                  displayAs: 2,
                },
              },
              {
                meta: {
                  component: 'ProductPrice',
                },
                content: {
                  alignment: 'left',
                },
              },
              {
                meta: {
                  component: 'ProductAddToCartButton',
                },
                content: {
                  label: 'Add to cart',
                  variant: 'cta',
                  alignment: 'left',
                  eventType: 'addToCart',
                },
              },
            ],
          ],
        },
        {
          meta: {
            component: 'ProductDescription',
          },
          content: {
            alignment: 'left',
          },
        },
      ],
    },
    {
      label: 'Registration',
      template: 'FreeformPage',
      thumbnail: 'web-form-page.png',
      preset: 'registration',
      content: [
        {
          meta: {
            _columns: 3,
            layout: 'auto 400px auto',
            component: 'Container',
            isFullWidth: false,
          },
          content: [
            [],
            [
              {
                meta: {
                  component: 'Title',
                },
                content: {
                  level: 1,
                  title: 'Create an account',
                  alignment: 'left',
                  textAlignment: 'left',
                },
              },
              {
                meta: {
                  _columns: 2,
                  component: 'Container',
                  isFullWidth: false,
                },
                styles: { columnGap: '1rem' },
                content: [
                  [
                    {
                      meta: {
                        component: 'TextField',
                      },
                      content: {
                        path: 'person.name.firstName',
                        type: 'text',
                        label: 'First name',
                        formId: 'registration',
                        preFill: false,
                        isRequired: true,
                      },
                    },
                  ],
                  [
                    {
                      meta: {
                        component: 'TextField',
                      },
                      content: {
                        path: 'person.name.lastName',
                        type: 'text',
                        label: 'Last name',
                        formId: 'registration',
                        preFill: false,
                        isRequired: true,
                      },
                    },
                  ],
                ],
              },
              {
                meta: {
                  component: 'TextField',
                },
                content: {
                  path: 'personalEmail.address',
                  type: 'email',
                  label: 'Email address',
                  formId: 'registration',
                  preFill: false,
                  isRequired: true,
                },
              },

              {
                meta: {
                  component: 'TextField',
                },
                content: {
                  path: 'homeAddress.street1',
                  type: 'text',
                  label: 'Address',
                  formId: 'registration',
                  preFill: false,
                  isRequired: false,
                },
              },
              {
                meta: {
                  _columns: 2,
                  component: 'Container',
                },
                styles: { columnGap: '1rem' },
                content: [
                  [
                    {
                      meta: {
                        component: 'TextField',
                      },
                      content: {
                        path: 'homeAddress.postalCode',
                        type: 'text',
                        label: 'ZIP code',
                        formId: 'registration',
                        preFill: false,
                        isRequired: false,
                      },
                    },
                  ],
                  [
                    {
                      meta: {
                        component: 'TextField',
                      },
                      content: {
                        path: 'homeAddress.city',
                        type: 'text',
                        label: 'City',
                        formId: 'registration',
                        preFill: false,
                        isRequired: false,
                      },
                    },
                  ],
                ],
              },
              {
                meta: {
                  _columns: 2,
                  component: 'Container',
                },
                styles: { columnGap: '1rem' },
                content: [
                  [
                    {
                      meta: {
                        component: 'TextField',
                      },
                      content: {
                        path: 'mobilePhone.number',
                        type: 'tel',
                        label: 'Phone number',
                        formId: 'registration',
                        preFill: false,
                        isRequired: false,
                      },
                    },
                  ],
                  [
                    {
                      meta: {
                        component: 'DateField',
                      },
                      content: {
                        name: 'birthDate',
                        path: 'person.birthDate',
                        type: 'text',
                        label: 'Date of birth',
                        formId: 'registration',
                        format: 'YYYY-MM-DD',
                        preFill: true,
                        alignment: 'left',
                        isRequired: false,
                      },
                    },
                  ],
                ],
              },

              {
                meta: { component: 'Title' },
                content: {
                  level: 4,
                  title: 'Communication preferences',
                  alignment: 'left',
                  textAlignment: 'left',
                },
              },
              {
                meta: {
                  _columns: 3,
                  component: 'Container',
                  isFullWidth: false,
                },
                content: [
                  [
                    {
                      meta: {
                        component: 'Switch',
                      },
                      content: {
                        path: 'consents.marketing.email.val',
                        type: 'Switch',
                        label: 'Email',
                        preFill: false,
                        alignment: 'left',
                        direction: 'vertical',
                      },
                    },
                  ],
                  [
                    {
                      meta: {
                        component: 'Switch',
                      },
                      content: {
                        path: 'consents.marketing.call.val',
                        type: 'Switch',
                        label: 'Phone',
                        preFill: false,
                        alignment: 'left',
                        direction: 'vertical',
                      },
                    },
                  ],
                  [
                    {
                      meta: {
                        component: 'Switch',
                      },
                      content: {
                        path: 'consents.marketing.sms.val',
                        type: 'Switch',
                        label: 'SMS',
                        preFill: false,
                        alignment: 'left',
                        direction: 'vertical',
                      },
                    },
                  ],
                ],
              },
              {
                meta: {
                  component: 'Button',
                },
                content: {
                  link: 'sign-in',
                  delay: 2000,
                  label: 'Submit',
                  formId: 'registration',
                  variant: 'cta',
                  alignment: 'left',
                  eventType: 'registration',
                  toastMessage: '',
                  toastVariant: '',
                },
                styles: { marginTop: '1rem' },
              },
            ],
            [],
          ],
          styles: {
            customClasses: 'sc--wideFields',
          },
        },
      ],
    },
  ],
  defaultTemplate: {
    name: 'new-screen',
    title: `New Screen`,
    template: 'FreeformPage',
    preset: 'default',
    content: [],
  },
  unknownTemplate: 'web-hero-page.png',
  navigationAlignmentOptions: [
    { label: 'Left', value: 'left', default: true },
    { label: 'Center', value: 'center' },
    { label: 'Right', value: 'right' },
  ],
  navigationVisibilityOptions: [
    { label: 'Always visible', value: 'alwaysVisible', default: true },
    { label: 'Hidden', value: 'hidden' },
    { label: 'Show on scroll', value: 'visibleOnScroll' },
  ],
  logoPositionOptions: [
    { label: 'Left', value: 'left', default: true },
    { label: 'Top', value: 'top' },
  ],
  authOptions: [
    { label: 'Always', value: 'always' },
    { label: 'Optional', value: 'optional' },
    { label: 'None', value: 'none' },
  ],
  chatBotOptions: {
    sinch: [
      {
        label: 'Retail',
        value: 'lrq8wxd5:65af9d1643234f70068f44c8',
        params: {
          proposedProductName: 'Sprite Yoga Companion Kit',
          proposedProductUrl: 'https://dsn.adobe.com/web/luma3/product?productId=24-WG085_Group',
          proposedProductImage:
            'https://demo-system-next.s3.amazonaws.com/assets/luma/products/luma-yoga-strap-set.jpg',
        },
        requiredParams: ['proposedProductName', 'proposedProductUrl', 'proposedProductImage'],
        optionalParams: ['title', 'botDisplayName', 'brandColor', 'actionColor', 'conversationColor'],
      },
      {
        label: 'Healthcare',
        value: 'lhssq3fl:65f1f4ecaffe44e260c03c86',
        optionalParams: ['title', 'botDisplayName', 'brandColor', 'actionColor', 'conversationColor'],
      },
      {
        label: 'FSI',
        value: 'loww5owj:655241a5e0089e24ddba0f9d',
        optionalParams: ['title', 'botDisplayName', 'brandColor', 'actionColor', 'conversationColor'],
      },
    ],
  },
}
